import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

class HouseAreaList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };

    render() {
        const { content } = this.props;

        return <div className={styles.area_list} dangerouslySetInnerHTML={{ __html: content }} />;
    }
}

export default errorBoundary(HouseAreaList);
